(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeRace', TypeRace);

    TypeRace.$inject = ['$resource'];

    function TypeRace ($resource) {
        var resourceUrl =  'api/type-races/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-races/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
